module.exports = __webpack_public_path__ + "img/logo_small.881a120c.png";